import { defineProperty as _defineProperty, taggedTemplateLiteral as _taggedTemplateLiteral } from '../../_virtual/_rollupPluginBabelHelpers.js';
import styled from 'styled-components';
import { BADGE_VARIANTS } from './Badge.constants.js';

var _templateObject;
var DATA_VIS_COLOUR_TOKENS = _defineProperty(_defineProperty(_defineProperty(_defineProperty(_defineProperty(_defineProperty(_defineProperty(_defineProperty({}, BADGE_VARIANTS.DATA_VIS_1, 'dataObjects.default.n1'), BADGE_VARIANTS.DATA_VIS_2, 'dataObjects.default.n2'), BADGE_VARIANTS.DATA_VIS_3, 'dataObjects.default.n3'), BADGE_VARIANTS.DATA_VIS_4, 'dataObjects.default.n4'), BADGE_VARIANTS.DATA_VIS_5, 'dataObjects.default.n5'), BADGE_VARIANTS.DATA_VIS_6, 'dataObjects.default.n6'), BADGE_VARIANTS.DATA_VIS_7, 'dataObjects.default.n7'), BADGE_VARIANTS.DATA_VIS_8, 'dataObjects.default.n8');
var getColorFromTokens = function getColorFromTokens(theme, variant, colorType) {
  var path = DATA_VIS_COLOUR_TOKENS[variant].split('.');
  var color = path.reduce(function (acc, key) {
    return acc[key];
  }, theme.colours.visualisations);
  return color[colorType];
};
var getBadgeBackgroundColor = function getBadgeBackgroundColor(_ref) {
  var theme = _ref.theme,
    $variant = _ref.$variant,
    $hasBackground = _ref.$hasBackground;
  if (!$hasBackground) {
    return 'transparent';
  }
  if ($variant === BADGE_VARIANTS.SUBTLE) {
    return theme.colours.canvas.secondary.main;
  }
  if (DATA_VIS_COLOUR_TOKENS[$variant]) {
    return getColorFromTokens(theme, $variant, 'main');
  }
  return theme.colours.messaging[$variant].main;
};
var getBadgeColor = function getBadgeColor(_ref2) {
  var theme = _ref2.theme,
    $variant = _ref2.$variant,
    $hasBackground = _ref2.$hasBackground;
  if (!$hasBackground) {
    return theme.colours.ink.primary.main;
  }
  if ($variant === BADGE_VARIANTS.SUBTLE) {
    return theme.colours.canvas.secondary.ink;
  }
  if (DATA_VIS_COLOUR_TOKENS[$variant]) {
    return getColorFromTokens(theme, $variant, 'ink');
  }
  return theme.colours.messaging[$variant].ink;
};
var StyledBadge = styled.span(_templateObject || (_templateObject = _taggedTemplateLiteral(["\n  display: inline-flex;\n  align-items: center;\n  justify-content: center;\n  gap: ", ";\n  background-color: ", ";\n  color: ", ";\n  padding: ", ";\n  ", "\n\n  svg {\n    opacity: ", ";\n  }\n"])), function (_ref3) {
  var theme = _ref3.theme;
  return theme.sizing.xtiny;
}, getBadgeBackgroundColor, getBadgeColor, function (_ref4) {
  var theme = _ref4.theme;
  return "".concat(theme.sizing.tiny, " ").concat(theme.sizing.small);
}, function (_ref5) {
  var theme = _ref5.theme;
  return theme.typography.bodySmall;
}, function (_ref6) {
  var theme = _ref6.theme;
  return theme.opacity.secondary;
});
var StyledBadge$1 = StyledBadge;

export { StyledBadge$1 as default, getBadgeBackgroundColor, getBadgeColor };
//# sourceMappingURL=Badge.styles.js.map
